import { Modal, ModalHeader, ModalTitle } from "react-bootstrap";


/**
 * Wraps a content component inside a React-Bootstrap Modal.
 * The wrapped component should ONLY render its content (no Modal.* inside).
 * You can pass an optional renderFooter(props) to draw custom footer buttons.
 */
const withModal = (Component) => {
  return function ModalWrapper({
    isOpen = false,
    onClose = () => {},
    className = "",
    title = "",
    size = "md",
    centered = true,
    backdrop = true,
    keyboard = true,
    scrollable = false,
    dialogClassName = "",
    ...props
  }) {
    if (!isOpen) return null;

    return (
      <Modal
        show={isOpen}
        onHide={onClose}
        size={size}
        centered={centered}
        backdrop={backdrop}
        keyboard={keyboard}
        scrollable={scrollable}
        className={className}
        dialogClassName={dialogClassName}
      >
        <ModalHeader closeButton>
          <ModalTitle>{title}</ModalTitle>
        </ModalHeader>

        {/* The content component should NOT render Modal.Body/Footer */}
        <Component {...props} onClose={onClose} />
      </Modal>
    );
  };
};

export default withModal;
